// Bottle and Quantity Switcher Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Content for different bottle types
  const bottleContent = {
    standard: {
      // bundle-includes content
      image: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857",
      title: "1 JuiceBox™ Trinkflasche",
      originalPrice: "9,90€",
      discountedPrice: "0,00€",
      headlineText: "Heute GRATIS im Set:",
      listItemText: "<span>✓</span> <strong>1x&nbsp;</strong> Trinkflasche",
      
      // accordion content
      accordionImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857",
      accordionTitle: "Trinkflasche",
      accordionBadge: "Gratis"
    },
    premium: {
      // bundle-includes content
      image: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/glass_bottle_no_badge.webp?v=1740401399",
      title: "1 JuiceBox™ Glastrinkflasche 1 L",
      originalPrice: "24,90€",
      discountedPrice: "9,90€",
      headlineText: "Deine Set-Vorteile:",
      listItemText: "<span>✓</span> <strong>1x&nbsp;</strong> Glastrinkflasche 1 L",
      
      // accordion content
      accordionImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/glass_bottle_no_badge.webp?v=1740401399",
      accordionTitle: "Glastrinkflasche 1 L",
      accordionBadge: "spare €15,00"
    }
  };
  
  // Content for different quantities
  const quantityContent = {
    2: "<span>✓</span> <strong>2x&nbsp;</strong> JuiceBox™ (frei wählbar)",
    3: "<span>✓</span> <strong>3x&nbsp;</strong> JuiceBox™ (frei wählbar)",
    5: "<span>✓</span> <strong>5x&nbsp;</strong> JuiceBox™ (frei wählbar)"
  };
  
  // Content for different portions based on quantity
  const portionsContent = {
    2: "Bis zu 400 Portionen",
    3: "Bis zu 600 Portionen", 
    5: "Bis zu 1000 Portionen"
  };
  
  // Content for different specs based on quantity
  const specsContent = {
    2: {
      literImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/100li.webp?v=1739011941",
      literText: "Bis zu 100 Liter Getränke/Set",
      petText: "Spart bis zu 200 PET-Flaschen"
    },
    3: {
      literImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/150li.webp?v=1747914533",
      literText: "Bis zu 150 Liter Getränke/Set",
      petText: "Spart bis zu 300 PET-Flaschen"
    },
    5: {
      literImage: "https://cdn.shopify.com/s/files/1/0512/4289/3477/files/250li.webp?v=1752813364",
      literText: "Bis zu 250 Liter Getränke/Set",
      petText: "Spart bis zu 500 PET-Flaschen"
    }
  };
  
  // Content for "warum" section based on quantity
  const warumContent = {
    2: {
      literText: "Bis zu 100 Liter Ausbeute",
      petText: "Spart bis zu 200 PET-Flaschen"
    },
    3: {
      literText: "Bis zu 150 Liter Ausbeute",
      petText: "Spart bis zu 300 PET-Flaschen"
    },
    5: {
      literText: "Bis zu 250 Liter Ausbeute",
      petText: "Spart bis zu 500 PET-Flaschen"
    }
  };
  
  // Pricing configuration for different combinations
  const pricingConfig = {
    standard: {
      2: { price: 59.90, comparePrice: 89.50 },
      3: { price: 79.90, comparePrice: 124.30 },
      5: { price: 129.90, comparePrice: 184.00 }
    },
    premium: {
      2: { price: 69.80, comparePrice: 104.50 },
      3: { price: 89.80, comparePrice: 139.30 },
      5: { price: 139.80, comparePrice: 199.00 }
    }
  };
  
  // Function to format price in euros
  function formatPrice(price) {
    return price.toFixed(2).replace('.', ',') + '€';
  }
  
  // Function to calculate discount percentage
  function calculateDiscountPercentage(originalPrice, salePrice) {
    return Math.round(((originalPrice - salePrice) / originalPrice) * 100);
  }
  
  // Function to update pricing display
  function updatePricing(bottleType, quantity) {
    const pricing = pricingConfig[bottleType] && pricingConfig[bottleType][quantity];
    if (!pricing) return;
    
    const elements = {
      comparePrice: document.getElementById('compared-price-display'),
      salePrice: document.getElementById('product-price-display'),
      discountBadge: document.getElementById('discount-percentage-badge')
    };
    
    const savings = pricing.comparePrice - pricing.price;
    
    // Update pricing elements
    if (elements.comparePrice) {
      elements.comparePrice.textContent = formatPrice(pricing.comparePrice);
    }
    if (elements.salePrice) {
      elements.salePrice.textContent = formatPrice(pricing.price);
    }
    if (elements.discountBadge) {
      elements.discountBadge.textContent = `SPARE ${formatPrice(savings)}`;
    }
  }
  
  // Function to update all bottle-related content
  function updateBottleContent(bottleType) {
    const content = bottleContent[bottleType];
    
    // Update all elements by ID
    const elements = {
      // bundle-includes elements
      image: document.getElementById('bottle-image-display'),
      heading: document.getElementById('bottle-heading'),
      title: document.getElementById('bottle-title'),
      originalPrice: document.getElementById('bottle-original-price'),
      discountedPrice: document.getElementById('bottle-discounted-price'),
      listItem: document.getElementById('bottle-list-item'),
      
      // accordion elements
      accordionImage: document.getElementById('accordion-bottle-image'),
      accordionTitle: document.getElementById('accordion-bottle-title'),
      accordionBadge: document.getElementById('accordion-bottle-badge')
    };
    
    // Set content for each element if it exists
    if (elements.image) elements.image.src = content.image;
    if (elements.heading) elements.heading.textContent = content.headlineText;
    if (elements.title) elements.title.textContent = content.title;
    if (elements.originalPrice) elements.originalPrice.textContent = content.originalPrice;
    if (elements.discountedPrice) elements.discountedPrice.textContent = content.discountedPrice;
    if (elements.listItem) elements.listItem.innerHTML = content.listItemText;
    
    // Set accordion content
    if (elements.accordionImage) elements.accordionImage.src = content.accordionImage;
    if (elements.accordionTitle) elements.accordionTitle.textContent = content.accordionTitle;
    if (elements.accordionBadge) elements.accordionBadge.textContent = content.accordionBadge;
    
    // Update pricing based on current selections
    updatePricingForCurrentSelections();
  }
  
  // Function to get current bottle selection
  function getCurrentBottleType() {
    const activeBottleCard = document.querySelector('.JB-bottle-card.active');
    if (activeBottleCard) {
      const bottleValue = activeBottleCard.querySelector('input[type="text"]').value;
      return bottleValue === 'premium-bottle' ? 'premium' : 'standard';
    }
    return 'standard'; // default
  }
  
  // Function to get current quantity selection
  function getCurrentQuantity() {
    const activeQuantityCard = document.querySelector('.quantity-card.active');
    if (activeQuantityCard) {
      return parseInt(activeQuantityCard.getAttribute('data-quantity'));
    }
    return 3; // default
  }
  
  // Function to update pricing based on current selections
  function updatePricingForCurrentSelections() {
    const bottleType = getCurrentBottleType();
    const quantity = getCurrentQuantity();
    updatePricing(bottleType, quantity);
  }
  
  // Function to update portions display
  function updatePortionsContent(quantity) {
    const portionsElement = document.getElementById('portions-display');
    if (portionsElement && portionsContent[quantity]) {
      portionsElement.textContent = portionsContent[quantity];
    }
  }
  
  // Function to update specs display
  function updateSpecsContent(quantity) {
    const specsData = specsContent[quantity];
    if (!specsData) return;
    
    const elements = {
      literImage: document.getElementById('specs-liter-image'),
      literText: document.getElementById('specs-liter-text'),
      petText: document.getElementById('specs-pet-text')
    };
    
    // Update liter image and text
    if (elements.literImage) {
      elements.literImage.src = specsData.literImage;
    }
    if (elements.literText) {
      elements.literText.textContent = specsData.literText;
    }
    
    // Update PET bottles text
    if (elements.petText) {
      elements.petText.textContent = specsData.petText;
    }
  }
  
  // Function to update "warum" section display
  function updateWarumContent(quantity) {
    const warumData = warumContent[quantity];
    if (!warumData) return;
    
    const elements = {
      literText: document.getElementById('warum-liter-text'),
      petText: document.getElementById('warum-pet-text')
    };
    
    // Update liter ausbeute text
    if (elements.literText) {
      elements.literText.textContent = warumData.literText;
    }
    
    // Update PET bottles text
    if (elements.petText) {
      elements.petText.textContent = warumData.petText;
    }
  }
  
  // Function to update bundle-set-info additional items visibility
  function updateBundleSetInfoItems(quantity) {
    // Get elements
    const geschirrtuchListItem = document.getElementById('geschirrtuch-list-item');
    const glastrinkhalmeListItem = document.getElementById('glastrinkhalme-list-item');
    const geschirrtuchGiftBlock = document.getElementById('geschirrtuch-gift-block');
    const glastrinkhalmeGiftBlock = document.getElementById('glastrinkhalme-gift-block');
    
    // Hide all by default
    if (geschirrtuchListItem) geschirrtuchListItem.style.display = 'none';
    if (glastrinkhalmeListItem) glastrinkhalmeListItem.style.display = 'none';
    if (geschirrtuchGiftBlock) geschirrtuchGiftBlock.style.display = 'none';
    if (glastrinkhalmeGiftBlock) glastrinkhalmeGiftBlock.style.display = 'none';
    
    // Show based on quantity
    if (quantity === 3) {
      // Mega: Show only Premium Geschirrtuch
      if (geschirrtuchListItem) geschirrtuchListItem.style.display = 'flex';
      if (geschirrtuchGiftBlock) geschirrtuchGiftBlock.style.display = 'block';
    } else if (quantity === 5) {
      // Maxi: Show both Premium Geschirrtuch and Glastrinkhalme
      if (geschirrtuchListItem) geschirrtuchListItem.style.display = 'flex';
      if (glastrinkhalmeListItem) glastrinkhalmeListItem.style.display = 'flex';
      if (geschirrtuchGiftBlock) geschirrtuchGiftBlock.style.display = 'block';
      if (glastrinkhalmeGiftBlock) glastrinkhalmeGiftBlock.style.display = 'block';
    }
  }
  
  // Function to update quantity-related content
  function updateQuantityContent(quantity) {
    const quantityElement = document.getElementById('juicebox-quantity-item');
    if (quantityElement && quantityContent[quantity]) {
      quantityElement.innerHTML = quantityContent[quantity];
    }
    
    // Update accordion juice box cards
    updateAccordionJuiceBoxes(quantity);
    
    // Update portions display
    updatePortionsContent(quantity);
    
    // Update specs display
    updateSpecsContent(quantity);
    
    // Update "warum" section display
    updateWarumContent(quantity);
    
    // Update bundle-set-info additional items visibility
    updateBundleSetInfoItems(quantity);
    
    // Update pricing based on current selections
    updatePricingForCurrentSelections();
  }
  
  // Function to update juice box cards in accordion
  function updateAccordionJuiceBoxes(quantity) {
    const container = document.getElementById('accordion-juicebox-container');
    if (!container) return;
    
    // Clear existing juice box cards (keep only Genussbox and bottle cards)
    const existingCards = container.querySelectorAll('.jb-small-card');
    const genussboxCard = Array.from(existingCards).find(card => 
      card.querySelector('p')?.textContent.includes('Genussbox')
    );
    const bottleCard = Array.from(existingCards).find(card => 
      card.querySelector('#accordion-bottle-image')
    );
    
    // Clear container
    container.innerHTML = '';
    
    // Generate juice box cards based on quantity
    for (let i = 1; i <= quantity; i++) {
      const isGratis = (quantity === 2 && i === 2) || 
                      (quantity === 3 && i === 3) || 
                      (quantity === 5 && i === 5);
      
      const cardHtml = `
        <div class="jb-small-card">
          ${isGratis ? '<div class="jb-badge">Gratis</div>' : ''}
          <img
            src="https://cdn.shopify.com/s/files/1/0512/4289/3477/files/Gratis_im_Set_Box.jpg?v=1731403373"
            alt="JuiceBox™ deiner Wahl"
          >
          <p>JuiceBox™ deiner Wahl</p>
          <p>inkludiert</p>
        </div>
      `;
      
      container.insertAdjacentHTML('beforeend', cardHtml);
    }
    
    // Re-add Genussbox card
    if (genussboxCard) {
      container.appendChild(genussboxCard);
    } else {
      // Create default Genussbox card if it doesn't exist
      const genussboxHtml = `
        <div class="jb-small-card">
          <img
            src="https://cdn.shopify.com/s/files/1/0512/4289/3477/files/jb_genussbox_doppelset_listing_open.webp?v=1750938666"
            alt="JuiceBox™ Genussbox"
          >
          <p>Genussbox Set 16 Proben</p>
          <p>inkludiert</p>
        </div>
      `;
      container.insertAdjacentHTML('beforeend', genussboxHtml);
    }
    
    // Re-add bottle card
    if (bottleCard) {
      container.appendChild(bottleCard);
    } else {
      // Create default bottle card if it doesn't exist
      const bottleHtml = `
        <div class="jb-small-card">
          <div id="accordion-bottle-badge" class="jb-badge">Gratis</div>
          <img
            id="accordion-bottle-image"
            src="https://cdn.shopify.com/s/files/1/0512/4289/3477/files/IMG-2943.jpg?v=1729057857"
            alt="JuiceBox™ deiner Wahl"
          >
          <p id="accordion-bottle-title">Trinkflasche</p>
          <p>inkludiert</p>
        </div>
      `;
      container.insertAdjacentHTML('beforeend', bottleHtml);
    }
    
    // Add additional free items for Mega and Maxi
    if (quantity === 3) {
      // Mega gets Premium Geschirrtuch
      const geschirrtuchHtml = `
        <div class="jb-small-card">
          <div class="jb-badge">Gratis</div>
          <img
            src="https://cdn.shopify.com/s/files/1/0512/4289/3477/files/Premium_Geschirrtuch_for_Set.webp?v=1753196409"
            alt="Premium Geschirrtuch"
          >
          <p>Premium Geschirrtuch</p>
          <p>inkludiert</p>
        </div>
      `;
      container.insertAdjacentHTML('beforeend', geschirrtuchHtml);
    } else if (quantity === 5) {
      // Maxi gets Premium Geschirrtuch + Glastrinkhalme
      const geschirrtuchHtml = `
        <div class="jb-small-card">
          <div class="jb-badge">Gratis</div>
          <img
            src="https://cdn.shopify.com/s/files/1/0512/4289/3477/files/Premium_Geschirrtuch_for_Set.webp?v=1753196409"
            alt="Premium Geschirrtuch"
          >
          <p>Premium Geschirrtuch</p>
          <p>inkludiert</p>
        </div>
      `;
      const glastrinkhalmeHtml = `
        <div class="jb-small-card">
          <div class="jb-badge">Gratis</div>
          <img
            src="https://cdn.shopify.com/s/files/1/0512/4289/3477/files/strohalm-freisteller-2_f890415d-5186-43ae-b9d5-32c0862bc097.jpg?v=1705644179"
            alt="Glastrinkhalme"
          >
          <p>Glastrinkhalme</p>
          <p>inkludiert</p>
        </div>
      `;
      container.insertAdjacentHTML('beforeend', geschirrtuchHtml);
      container.insertAdjacentHTML('beforeend', glastrinkhalmeHtml);
    }
  }
  
  // Observer to watch for changes to the bottle and quantity selection
  function initSwitchers() {
    const bottleCards = document.querySelectorAll('.JB-bottle-card');
    const quantityCards = document.querySelectorAll('.quantity-card');
    
    if (bottleCards.length === 0 && quantityCards.length === 0) return false;
    
    // Observer for bottle changes
    const bottleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const targetElement = mutation.target;
          if (targetElement.classList.contains('active')) {
            const bottleTypeValue = targetElement.querySelector('input[type="text"]').value;
            updateBottleContent(bottleTypeValue === 'premium-bottle' ? 'premium' : 'standard');
          }
        }
      });
    });
    
    // Observer for quantity changes
    const quantityObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const targetElement = mutation.target;
          if (targetElement.classList.contains('active')) {
            const quantity = targetElement.getAttribute('data-quantity');
            updateQuantityContent(parseInt(quantity));
          }
        }
      });
    });
    
    // Start observing the bottle selection cards
    bottleCards.forEach(card => {
      bottleObserver.observe(card, { attributes: true });
    });
    
    // Start observing the quantity selection cards
    quantityCards.forEach(card => {
      quantityObserver.observe(card, { attributes: true });
    });
    
    // Set initial content based on which cards are active
    bottleCards.forEach(card => {
      if (card.classList.contains('active')) {
        const bottleTypeValue = card.querySelector('input[type="text"]').value;
        updateBottleContent(bottleTypeValue === 'premium-bottle' ? 'premium' : 'standard');
      }
    });
    
    quantityCards.forEach(card => {
      if (card.classList.contains('active')) {
        const quantity = card.getAttribute('data-quantity');
        updateQuantityContent(parseInt(quantity));
      }
    });
    
    return true;
  }
  
  // Try to initialize, retry with a delay if elements aren't available yet
  if (!initSwitchers()) {
    const checkInterval = setInterval(function() {
      if (initSwitchers()) {
        clearInterval(checkInterval);
      }
    }, 500);
  }
});

// End Bottle and Quantity Switcher Functionality